import React, { useState } from "react";
import styles from '../styles/defaultCard.module.scss'
import Icon from "@/wmCompoments/Icon";
import Toast from "@/wmCompoments/toast";
import { CardType, getWalletLocalConfig } from "@/utils/wallet";
import { useCardList, useDeleteCard } from "@/api/request";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import DeleteConfirm from "../dialog/deleteConfirm";
import { useTranslation } from "react-i18next";


interface Props {
    data: any
}
const HuiwangCard = (props: Props) => {
    const { data } = props
    const { t } = useTranslation('accountManagement')
    const handleCopy = (v)=> {
        if(ut.copyBoard(v)) {
            Toast.show(t('copySuccess'))
        }
    }

    const conifg = getWalletLocalConfig(CardType.Huiwangpay);
    const [visible, setVisible] = useState(false)
    const { trigger } = useDeleteCard(conifg?.delApi)
    const { mutate } = useCardList(conifg?.api)
    const onClickDelete = () => {
        setVisible(true)
    }
    const handleDelete = async () => {
        try {
            await trigger({
                id: data?.id,
                /**暂不清楚该字段含义 */
                twoPassword: ''
            })
            await mutate()
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
        }
    }

    return <div className={styles.item}>
        <div className={styles.warpper}>
            <div className={styles.top}>
                <Icon name={'icon-crypto-card'} className={styles.cryptoIcon} />
                <span>{data?.alias}</span>
                <Icon name={'icon-general-delete'} className={styles.iconDelete} onClick={()=>onClickDelete()}/>
            </div>
            <div className={styles.bottom}>
                <div>
                    <span>{t('walletAddress')}</span>
                </div>
                <div>
                    <span>{data?.huiwangAccountId}</span>
                    <div className={styles.copyWarpper} onClick={()=>{
                        handleCopy(data?.huiwangAccountId)
                    }}>
                        <Icon name={'icon-games-copy'}/>
                        <span>{t('copy')}</span>
                    </div>
                </div>      
            </div>
        </div>
        <DeleteConfirm visible={visible} onClose={() => {
            setVisible(false)
        }}
            onSubmit={handleDelete}
        />
    </div>
}

export default HuiwangCard